import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/AusumConfiguration`;

export const getConfigurations = async () => {
  const response = await fetch(baseRoute, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const getSweepTypes = async () => {
  const response = await fetch(`${baseRoute}/sweepTypes`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const getConfiguration = async (configId) => {
  const response = await fetch(`${baseRoute}/${configId}`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const createConfiguration = async (configData) => {
  const response = await fetch(baseRoute, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(configData),
  });
  if (response.ok) {
    return true; // Return true for any successful response
  }
  // Only try to parse error responses
  const errorData = await response.json();
  return Promise.reject(errorData);
};

export const updateConfiguration = async (configId, configData) => {
  const response = await fetch(`${baseRoute}/${configId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(configData),
  });
  if (response.ok) {
    return true; // Return true for any successful response
  }
  // Only try to parse error responses
  const errorData = await response.json();
  return Promise.reject(errorData);
};

export const deleteConfiguration = async (configId) => {
  const response = await fetch(`${baseRoute}/${configId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const activateConfiguration = async (configId) => {
  const response = await fetch(`${baseRoute}/${configId}/activate`, {
    method: 'PUT',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const deactivateConfiguration = async (configId) => {
  const response = await fetch(`${baseRoute}/${configId}/deactivate`, {
    method: 'PUT',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

// Test connection to Ausum API with current configuration
export const testConnection = async (configId) => {
  const response = await fetch(`${baseRoute}/${configId}/test-connection`, {
    method: 'POST',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const createProduct = async (productData) => {
  const response = await fetch(`${baseRoute}/Product`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(productData),
  });
  if (response.ok) {
    return response.json();
  }
  const errorData = await response.json();
  return Promise.reject(errorData);
};